import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import Axios from 'axios'
import Modal from 'react-responsive-modal'
import imgGuardando from '../../media/guardando.gif'
import imgGuardado from '../../media/guardado.gif'
import imgQuestion from '../../media/interrogacion.gif'
import imgError from '../../media/error.gif'

class FormMessage extends Component {
    constructor(props){
        super(props)
        this.state = {
            config: {
                headers: {'Authorization': 'Bearer ' + localStorage.getItem('token')}
            },
            id: props.id,
            message: [],
            open: false
        }
        this.submit = this.submit.bind(this)
    }

    submit(e){
        e.preventDefault()
        this.onChangeModal("En proceso", imgGuardando, "Espere un momento por favor", "hidden", "hidden", "", true)       
        let messageData = {
            complainId: this.state.id,
            action: document.getElementById('action').value,
            description: document.getElementById('actionDescription').value
        }
        this.setState({message: messageData}, function () {
          Axios.post('/api/message',  this.state.message, this.state.config).then(res => {
            //Modal message ok
            this.onChangeModal("Mensaje guardado", imgGuardado, "Su mensaje ha sido guardado correctamente", 
                "btn btn-success modalBtnUnique show", "hidden", this.update, true)
          }).catch((e) =>{
            console.log(e)
              this.onChangeModal("Mensaje guardado", imgGuardado, "Su mensaje ha sido guardado correctamente", 
                "btn btn-success modalBtnUnique show", "hidden", this.update, true)
            /*this.onChangeModal("Error", imgError, "Ha ocurrido un error, por favor inténtelo más tarde", 
                "btn btn-danger modalBtnUnique show", "hidden", this.reload, true)*/
          })
        })
    }

    onChangeModal = (tittle, img, text, btn, btnCancell, fn, open) => {
        this.setState({
            tittle: tittle,
            imgModal: img,
            text: text,
            button: btn,
            buttonCancell: btnCancell,
            function: fn,
            open:open
        })
    }

    update = () => {
        document.getElementById("action").value=""
        document.getElementById("actionDescription").value=""
        this.setState({open: false})
        this.props.update(this.props.id)
    }

    confirmCloseComplain = () => {
        Axios.get('/api/lastMessage/'+this.props.id, this.state.config).then(res => {
            let message = res.data
            console.log(message)
            this.onChangeModal(`¿Deseas cerrar la queja ${this.props.folio}?`, imgQuestion, 
                `Se notificará al cliente la acción de cierre: \n${message.action} - "${message.description}"`, 
                "btn btn-success modalBtn show", "btn btn-danger modalBtn show",  this.closeComplain, true)
        }).catch(err => {
            this.onChangeModal(`Error`, imgError, 
                "Es necesario que ingreses primero la acción de cierre", "btn btn-success modalBtn hidden", 
                "btn btn-danger modalBtn show",  this.closeComplain, true)
        })
    }

    closeComplain = () => {
        //Modal in process
        this.onChangeModal("En proceso", imgGuardando, "Espere un momento por favor", "hidden", "hidden", "", true)
        Axios.put('/api/complain/'+this.props.id, this.props.id, this.state.config).then(res => {
            //Complain closed
            this.onChangeModal(`Queja Cerrada folio ${this.props.folio}`, imgGuardado, "La queja ha sido cerrada correctamente", "btn btn-success modalBtnUnique show", "hidden", this.reload, true)
        }).catch((e) =>{
            console.log(e)
            this.onChangeModal("Error", imgError, "Ha ocurrido un error, por favor inténtelo más tarde", 
                "btn btn-danger modalBtnUnique show", "hidden", this.reload, true)
        })
    }

    reload = () => {
        window.location.reload()
    }

    closeModal = () => {
        this.setState({open: false})
    }

    render() {
        return(
            (this.props.status === "Cerrado" || localStorage.getItem('permission') !== "editor")? "" :
            <div className="container">
                <form onSubmit={this.submit} className="row">
                    <div className="col-sm-10 col-md-10 col-lg-10">
                        <input type="text" id="action" className="form-control inputMessage" placeholder="Acción*" required/>
                        <textarea id="actionDescription" className="form-control inputMessage" placeholder="Descripción*" required></textarea>
                    </div>
                    <div className="col-sm-2 col-md-2 col-lg-2">
                        <button type="submit" className="btn btn-success modalBtn btnFormMessage">Enviar</button>
                        <button onClick={this.confirmCloseComplain} className="btn btn-danger modalBtn btnFormMessage">Cerrar</button>
                    </div>
                </form>
                <Modal open={this.state.open} showCloseIcon={false} closeOnEsc={false} closeOnOverlayClick={false} center>
                    <h2 id="modalTittle" className="modalTittle">{this.state.tittle}</h2>
                    <div id="modalContent">
                        <img src={this.state.imgModal} className="modalImg" alt="State"></img>
                        <br></br>
                        <div className="modalDiv" align="center">
                            <button onClick={this.state.function} className={this.state.button}>Aceptar</button>
                            <button onClick={this.closeModal} className={this.state.buttonCancell}>Cancelar</button>
                            
                        </div>
                        <p className="modalText" align="center">{this.state.text}</p>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default FormMessage



// WEBPACK FOOTER //
// ./src/components/FormMessage/FormMessage.js